import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net-dt';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-tabella-configurazione-prodotto-container',
	templateUrl: './tabella-configurazione-prodotto-container.component.html',
})
export class TabellaConfigurazioneProdottoContainerComponent implements OnInit {
	@ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;
	@ViewChild('scegliProdottoModal', { static: false }) salvataggioModal: ElementRef;

	listaConfigurazioneProdottoContainer: any[] = [];
	listaGruppiConfigurazioneProdottoContainer: any[] = [];

	dtTrigger = new Subject();
	dtSettings: Config = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: true },
			{ searchable: false, targets: 1, orderable: true },
		],
	};

	constructor(
		private api: ApiService,
		private modalService: NgbModal,
	) {}

	ngOnInit(): void {
		this.api.getConfigurazioneProdottoContainer().subscribe((res) => {
			this.listaConfigurazioneProdottoContainer = res;
			this.dtTrigger.next();
		});

		this.aggiornaGruppi();
	}

	aggiungiConfigurazione() {
		this.listaConfigurazioneProdottoContainer.splice(0, 0, {
			sovrapponibilita: 1,
			feEdit: true,
			codice: '',
			terzoCarattere: '',
			ottavoCarattere: '',
		});

		this.datatableElement.dtInstance.then((api) => {
			api.destroy();
			this.dtTrigger.next();
		});
	}

	salvaConfigurazione(configurazione) {
		this.api.saveConfigurazioneProdottoContainer(configurazione).subscribe((res) => {
			if (res.id) {
				configurazione.feEdit = !configurazione.feEdit;
			} else {
				alert('Errore nel salvataggio della configurazione.');
			}
		});
	}

	deleteConfigurazione(configurazione) {
		if (confirm('Vuoi veramente eliminare la configurazione del codice ' + configurazione.codice + ' ?')) {
			this.api.removeConfigurazioneProdottoContainer({ id: configurazione.id }).subscribe(() => {
				this.listaConfigurazioneProdottoContainer.splice(this.listaConfigurazioneProdottoContainer.indexOf(configurazione), 1);
				this.datatableElement.dtInstance.then((api) => {
					api.destroy();
					this.dtTrigger.next();
				});
			});
		}
	}

	aggiornaGruppi() {
		this.api.getGruppoConfigurazioneProdottoContainer().subscribe((res) => {
			this.listaGruppiConfigurazioneProdottoContainer = res.map((g) => ({ ...g, sovrapponibilita: g.configurazioni[0]?.sovrapponibilita }));
		});
	}

	aggiungiGruppo() {
		this.listaGruppiConfigurazioneProdottoContainer.splice(0, 0, {
			configurazioni: [{ sovrapponibilita: 1, feEdit: true, codice: '', terzoCarattere: '', ottavoCarattere: '' }],
		});
	}

	aggiungiConfigurazioneAlGruppo(gruppo) {
		gruppo.configurazioni.push({ sovrapponibilita: 1, feEdit: true, codice: '', terzoCarattere: '', ottavoCarattere: '' });
	}

	salvaGruppo(gruppo) {
		gruppo.configurazioni = gruppo.configurazioni
			.filter((c) => c.codice)
			.map((c) => ({ ...c, sovrapponibilita: gruppo.sovrapponibilita, gruppo: undefined }));

		this.api.saveGruppoConfigurazioneProdottoContainer(gruppo).subscribe((res) => {
			if (!res.id) {
				alert('Errore nel salvataggio del gruppo.');
			} else {
				this.aggiornaGruppi();
				this.openSalvataggioModal();
			}
		});
	}

	rimuoviDalGruppo(configurazione, gruppo) {
		gruppo.configurazioni.splice(gruppo.configurazioni.indexOf(configurazione), 1);
	}

	openSalvataggioModal() {
		const ref = this.modalService.open(this.salvataggioModal);
		setTimeout(() => {
			ref.close();
		}, 1000);
	}
}
